/** @jsxRuntime classic */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'proxy-polyfill';

import * as React from 'react';

import App from './App';
import ReactDOM from 'react-dom';

// IE11 needs "jsxRuntime classic" for this initial file which means that "React" needs to be in scope
// https://github.com/facebook/create-react-app/issues/9906

ReactDOM.render(<App />, document.getElementById('root'));
